<!-- <template>
  <div class="sidebar-container">
    
    <el-menu
      :default-active="$route.path"
      router
      class="sidebar-menu"
      :collapse="isCollapse"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
    >
    
      <div class="sidebar-logo" @click="$router.push('/dashboard')">
        <el-icon><DataAnalysis /></el-icon>
        <span>报价管理系统</span>
      </div>
      
      <el-menu-item index="/dashboard">
        <el-icon><House /></el-icon>
        <span>首页</span>
      </el-menu-item>
      
      <el-menu-item index="/supplier" v-if="isLoggedIn">
        <el-icon><Document /></el-icon>
        <span>供应商报价</span>
      </el-menu-item>
      
      <el-menu-item index="/customer" v-if="isLoggedIn">
        <el-icon><ChatDotRound /></el-icon>
        <span>客户询价</span>
      </el-menu-item>
      
      <el-menu-item index="/users" v-if="isAdmin">
        <el-icon><User /></el-icon>
        <span>用户管理</span>
      </el-menu-item>
      <div class="collapse-btn" @click="toggleCollapse">
      <el-icon v-if="isCollapse"><Expand /></el-icon>
      <el-icon v-else><Fold /></el-icon>
    </div>
    </el-menu>
  </div>
</template>

<script>
import { 
  House, 
  Document, 
  ChatDotRound, 
  User,
  DataAnalysis,
  Fold,
  Expand
} from '@element-plus/icons-vue'

export default {
  
  name: 'SidebarConfig',
  props: {
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isLoggedIn() {
      return !!localStorage.getItem('token')
    },
    isAdmin() {
      const userStr = localStorage.getItem('user')
      const user = userStr ? JSON.parse(userStr) : null
      return user?.username === 'admin'
    }
  },
  methods: {
    toggleCollapse() {
      console.log("折叠状态切换:", !this.isCollapse)
      this.$emit('update:isCollapse', !this.isCollapse)
    }
  },
  components: {
    House, 
    Document, 
    ChatDotRound, 
    User,
    DataAnalysis,
    Fold,
    Expand
  }
}
</script>

<style scoped>
.sidebar-container {
  max-height: 100%;
  height: auto;
}

.sidebar-menu {
  border-right: none;
  height: 100%;
  transition: width 0.3s;
}

.sidebar-logo {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  border-bottom: 1px solid #263445;
}

.sidebar-logo .el-icon {
  font-size: 24px;
}

.sidebar-logo:hover {
  background-color: #263445;
}
.collapse-btn {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #bfcbd9;
  cursor: pointer;
  background-color: #263445;
  border-top: 1px solid #1f2d3d;
  transition: all 0.3s;
}

.collapse-btn:hover {
  background-color: #1f2d3d;
  color: #409EFF;
}
</style> -->

<!-- components/Sidebar/Sidebar.vue -->
<template>
  <div 
    class="sidebar" 
    :class="{
      'sidebar--collapsed': isCollapsed,
      'sidebar--mobile-open': isMobileOpen
    }"
  >
    <!-- 侧边栏头部 -->
    <div class="sidebar__header">
      <div class="sidebar__logo">
        <el-icon class="sidebar__logo-icon"><Management /></el-icon>
        
        <span 
          class="sidebar__logo-text"
          v-show="!isCollapsed"
        >
          报价管理系统
        </span>
      </div>
      
      <button 
        class="sidebar__toggle"
        @click="toggleSidebar"
        :title="isCollapsed ? '展开侧边栏' : '折叠侧边栏'"
      >
      <el-icon>
          <ArrowLeft v-if="!isCollapsed" />
          <ArrowRight v-else />
        </el-icon>
      </button>
    </div>

    <!-- 导航菜单 -->
    <nav class="sidebar__nav">
      <SidebarItem
        v-for="item in menuchose()"
        :key="item.id"
        :item="item"
        :collapsed="isCollapsed"
        :active="appStore.getActiveMenu === item.id"
        @click="handleItemClick(item)"
      />
    </nav>

    <!-- 底部区域 -->
    <!-- <div class="sidebar__footer" v-if="!isCollapsed">
      <div class="sidebar__user">
        <div class="sidebar__user-avatar">
          <i class="fas fa-user"></i>
        </div>
        <div class="sidebar__user-info">
          <div class="sidebar__user-name">管理员</div>
          <div class="sidebar__user-role">系统管理员</div>
        </div>
      </div>
    </div> -->
  </div>

  <!-- 移动端遮罩层 -->
  <div 
    v-if="isMobileOpen" 
    class="sidebar__overlay"
    @click="appStore.closeMobileSidebar"
  ></div>
</template>

<script setup>

import { computed, onMounted } from 'vue'
import { useAppStore ,useAuthStore} from '@/stores/auth'
import SidebarItem from './SidebarItem.vue'
import router from '@/router'
import {
  Management,
  ArrowLeft,
  ArrowRight,
  User as UserIcon
} from '@element-plus/icons-vue'

const appStore = useAppStore()
const authStore = useAuthStore()

// 计算属性
const isCollapsed = computed(() => appStore.isSidebarCollapsed)
const isMobileOpen = computed(() => appStore.isMobileSidebarOpen)
const menuchose=()=>{
  if(authStore.isAdmin){
  const menuItemss = [
    { id: 'dashboard', label: '首页', icon: 'DataAnalysis' },
    { id: 'supplier', label: '供应商报价', icon: 'Box' },
    { id: 'customer', label: '客户询价', icon: 'ShoppingCart' },
    { id: 'users', label: '用户管理', icon: UserIcon }
]
return menuItemss

}else{
  const menuItemss = [
  { id: 'dashboard', label: '首页', icon: 'DataAnalysis' },
  { id: 'supplier', label: '供应商报价', icon: 'Box' },
  { id: 'customer', label: '客户询价', icon: 'ShoppingCart' },
  // { id: 'users', label: '用户管理', icon: UserIcon },
  // { id: 'analytics', label: '数据统计', icon: 'fa-chart-bar' },
  ]
  return menuItemss
}

}


// 方法
const toggleSidebar = () => {
  Promise.resolve().then(() => {
    appStore.toggleSidebar()
  })
}

const handleItemClick = (item) => {
  appStore.setActiveMenu(item.id)
  // 根据菜单项跳转到对应路由
  switch(item.id) {
    case 'dashboard':
      router.push('/dashboard')
      break
    case 'supplier':
      router.push('/supplier')
      break
    case 'customer':
      router.push('/customer')
      break
    case 'users':
      router.push('/users')
      break
    default:
      router.push('/dashboard')
  }
}
onMounted(() => {
  menuchose()
})
</script>

<style scoped>
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 200px;
  background: linear-gradient(180deg, #2c3e50 0%, #34495e 100%);
  color: white;
  transition: all 0.3s ease;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
}

.sidebar--collapsed {
  width: 70px;
}

.sidebar__header {
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  min-height: 80px;
}

.sidebar__logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.sidebar__logo-icon {
  font-size: 24px;
  color: #3498db;
  min-width: 24px;
}

.sidebar__logo-text {
  font-size: 18px;
  font-weight: 600;
  white-space: nowrap;
  transition: opacity 0.3s;
}

.sidebar--collapsed .sidebar__logo-text {
  opacity: 0;
  width: 0;
}

.sidebar__toggle {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.sidebar__toggle:hover {
  background: rgba(255, 255, 255, 0.2);
}

.sidebar__nav {
  flex: 1;
  padding: 20px 0;
  overflow-y: auto;
}

.sidebar__footer {
  padding: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.sidebar__user {
  display: flex;
  align-items: center;
  gap: 12px;
}

.sidebar__user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(52, 152, 219, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3498db;
}

.sidebar__user-info {
  flex: 1;
}

.sidebar__user-name {
  font-weight: 600;
  font-size: 14px;
}

.sidebar__user-role {
  font-size: 12px;
  color: #bdc3c7;
}

.sidebar__overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .sidebar {
    transform: translateX(-100%);
  }

  .sidebar--mobile-open {
    transform: translateX(0);
  }

  .sidebar--collapsed {
    width: 260px;
    transform: translateX(-100%);
  }
}
</style>